import { defaultSystemCode, SystemCode } from '@/api'

export interface UpdateCollectionMemoCollectionInfoItem {
  collectionNo: string
  holdingBranchCode: SystemCode
  callNumber: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  updatedTime: string
  updatedBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  userId: string
}

export const defaultUpdateCollectionMemoInfoItem = (): UpdateCollectionMemoCollectionInfoItem => ({
  collectionNo: '',
  holdingBranchCode: defaultSystemCode(),
  callNumber: '',
  shelfType: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  appendixCode: defaultSystemCode(),
  updatedTime: '',
  updatedBranchCode: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  userId: ''
})
